module.exports = __webpack_public_path__ + "static/waitresses-14cb4c0da3ae78cb8f9292517970e6e8.jpg";